import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationStart, Router } from '@angular/router';
import { AppConfigService } from '@services/app-config/app-config.service';
import { AuthService } from '@services/auth/auth.service';
import { UiService } from '@services/category-lists/ui.service';
import { DataService } from '@services/data/data.service';
import { InitFilterRecordsService } from '@services/init-filter-records/init-filter-records.service';
import { IsAdminService } from '@services/is-admin/is-admin.service';
import { UsersService } from '@services/users/users.service';
import { SubscriptionBaseComponent } from './shared/subscription-base/subscription-base';

export let browserRefresh = false;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends SubscriptionBaseComponent implements OnInit {
  title = 'coudpouce';


  isAuth: boolean;
  isMaintenance: boolean;
  isError: boolean;
  isRouteLoading: boolean;
  isTranslationLoading: boolean;

  navMode = 'side';
  mobileQuery: MediaQueryList;

  private mobileQueryListener: () => void;

  constructor(
    private configSrv: AppConfigService,
    private uiSrv: UiService,
    private authSrv: AuthService,
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    private isAdminService: IsAdminService,
    private initFilterRecordsService: InitFilterRecordsService,
    private router: Router,
    private dataService: DataService,
    private userService: UsersService
  ) {
    super();

    this.mobileQuery = media.matchMedia('(max-width: 999px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
    this.isMaintenance = configSrv.isMaintenance;
    // this.initFilterRecordsService.getFilter();

  }

  ngOnInit(): void {
    this.isAuth = this.authSrv.isAuth();
    this.initSubscriptions();
  }

  toggleSidenav(sidenav: MatSidenav, isToggle?: boolean): void {
    if (isToggle) {
      sidenav.toggle();
    } else if (this.mobileQuery.matches) {
      sidenav.close();
    }
  }


  private initSubscriptions(): void {
    this.subscription.add(
      this.uiSrv.routeLoadingStateChanged
        .subscribe(loadingState => {
          this.isRouteLoading = loadingState;
          this.changeDetectorRef.detectChanges();

        })
    );

    this.subscription.add(
      this.uiSrv.translationLoadingStateChanged
        .subscribe(loadingState => {
          this.isTranslationLoading = loadingState;
          this.changeDetectorRef.detectChanges();

        })
    );

    this.subscription.add(
      this.authSrv.authChanged
        .subscribe(authStatus => {
          if (this.isAuth !== authStatus) {
            this.isAuth = authStatus;
          }
          this.changeDetectorRef.detectChanges();
        })
    );
  }

}
